import { $axios } from 'boot/axios';
import wizard from './wizard';

const defaultState = () => ({
  books: [],
  total: 0,
});

const actions = {
  async fetchBooks({ commit, state }, params = {}) {
    const { data } = (await $axios.get('generator/books', { params })).data;
    commit('setBooks', [...state.books, ...data.elements]);
    commit('setTotal', data.total);
  },
  async deleteBook({ commit, state }, guid) {
    await $axios.delete(`generator/books/${guid}`);
    commit('setBooks', state.books.filter((item) => item.guid !== guid));
  },
  async updateBookStatus({ commit, state }, { guid, status }) {
    const { data } = (await $axios.put(`generator/books/${guid}/status`, { status })).data;
    commit('setBooks', state.books.map((item) => (item.guid === guid ? data : item)));
  },
};

const mutations = {
  setBooks(state, payload) {
    state.books = payload;
  },
  setTotal(state, payload) {
    state.total = payload;
  },
  clear(state) {
    const clearState = defaultState();
    Object.keys(clearState).forEach((key) => {
      state[key] = clearState[key];
    });
  },
};

export default {
  namespaced: true,
  modules: { wizard },
  mutations,
  actions,
  state: defaultState,
};
